/* Progressive enhancement only: Shopify's native form performs locale routing. */
(() => {
  const switcher = document.getElementById('hp-language-switcher');
  if (!switcher || switcher.dataset.initialized) return;
  switcher.dataset.initialized = 'true';
  const summary = switcher.querySelector('summary');
  const form = switcher.querySelector('form');
  const buttons = [...switcher.querySelectorAll('button[name="language_code"]')];
  const close = (focus = false) => {
    switcher.open = false;
    if (focus) summary.focus();
  };
  switcher.addEventListener('toggle', () => {
    summary.setAttribute('aria-expanded', String(switcher.open));
  });
  summary.setAttribute('aria-expanded', String(switcher.open));
  document.addEventListener('click', event => {
    if (!switcher.contains(event.target)) close();
  });
  switcher.addEventListener('focusout', event => {
    if (event.relatedTarget && !switcher.contains(event.relatedTarget)) close();
  });
  switcher.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(true); }
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    switcher.open = true;
    const index = buttons.indexOf(document.activeElement);
    let next = event.key === 'ArrowUp' ? index - 1 : index + 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End' || (index === -1 && event.key === 'ArrowUp')) next = buttons.length - 1;
    buttons[(next + buttons.length) % buttons.length]?.focus();
  });
  form.addEventListener('submit', () => {
    // Preserve pagination, search filters and anchors. Shopify maps translated handles.
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    // Do not disable submit buttons: their language_code is part of native POST data.
  });
})();
